<template>
  <div class="profile-page">
    <section class="section-profile-cover section-shaped my-0">
      <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container shape-container d-flex search-hero-content">
        <div class="col px-0">
          <div class="row">
            <div class="col-12 col-lg-7">
              <h1 class="search-page-title" >
                Consulta de beneficiarios
                <span style="color:white;">Bono Juancito Pinto</span>
              </h1>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-skew default-bg">
      <div class="container">
        <card shadow class="card-profile mt--300 card-profile-crystal" no-body>
          <div class="px-4">
            <div class="text-center mt-5">
              <h2 style="color: #ffffff; font-weight: 750">
                Realiza tu Búsqueda
              </h2>

              <div class="row justify-content-center">
                <div class="col-12 col-lg-10 col-xl-9">
                  <div class="nav-wrapper">
                    <ul
                      class="nav nav-pills nav-fill flex-column flex-md-row"
                      role="tablist"
                    >
                      <li class="nav-item">
                        <a
                          class="nav-link mb-sm-3 mb-md-0"
                          @click="activeTab = 'tab1'"
                          :class="{ active: activeTab === 'tab1' }"
                          href="#"
                          role="tab"
                          aria-selected="true"
                        >
                          <i class="bx bx-search-alt-2 mr-2"></i>Búsqueda por
                          Estudiante
                        </a>
                      </li>
                      <li class="nav-item">
                        <a
                          class="nav-link mb-sm-3 mb-md-0"
                          @click="activeTab = 'tab2'"
                          :class="{ active: activeTab === 'tab2' }"
                          href="#"
                          role="tab"
                          aria-selected="false"
                        >
                          <i class="bx bx-search-alt-2 mr-2"></i>Búsqueda por
                          Titular
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div class="mt-4">
                    <transition name="fade" mode="out-in">
                      <div v-if="activeTab === 'tab1'">
                        <card
                          type="secondary"
                          shadow
                          header-classes="bg-white pb-5"
                          body-classes="px-lg-5 py-lg-5"
                          class="border-0 form-container-card"
                        >
                          <p v-if="!info" class="form-description">
                            Ingrese el RUDE y la fecha de nacimiento del
                            estudiante para verificar si es beneficiario.
                          </p>
                          <div
                            :class="`alert alert-${getStates(
                              state
                            )} keyrus-flex-center`"
                            role="alert"
                            v-if="state_message && has_state"
                          >
                            {{ state_message }}
                            <i
                              v-if="
                                !(
                                  state === 1 &&
                                  info &&
                                  info.roster_source === 'PAGO_ELECTRONICO'
                                )
                              "
                              class="bx bx-play-circle"
                              @click="playBJP"
                              style="font-size: 25px; padding-left: 5px"
                            ></i>
                          </div>

                          <div
                            class="alert alert-warning keyrus-flex-center"
                            role="alert"
                            v-if="state_message && !has_state"
                          >
                            <i
                              class="bx bx-info-circle"
                              style="font-size: 25px; padding-right: 5px"
                            ></i>
                            {{ state_message }}
                          </div>

                          <router-link
                            :to="{ name: 'public-entities' }"
                            v-if="
                              state === 1 &&
                              info &&
                              info.roster_source === 'CAJAS'
                            "
                            class="btn btn-primary btn-icon search-button"
                            >Entidades Autorizadas</router-link
                          >
                          <transition name="fade">
                            <div class="results-container" v-if="info">
                              <header class="results-heading">
                                <div>
                                  <span class="result-eyebrow">Resultado de la consulta</span>
                                  <h3>Información del estudiante</h3>
                                </div>
                                <span class="results-heading-icon" aria-hidden="true">
                                  <i class="bx bx-check-circle"></i>
                                </span>
                              </header>
                              <div class="result-grid">
                                <article class="result-card">
                                  <div class="result-card-header">
                                    <div>
                                      <span class="result-eyebrow"
                                        >Estudiante</span
                                      >
                                      <h5>Información del beneficiario</h5>
                                    </div>
                                  </div>
                                  <div class="person-summary">
                                    <div class="person-avatar" aria-hidden="true">
                                      <i class="bx bxs-graduation"></i>
                                    </div>
                                    <div class="person-summary__content">
                                      <span class="detail-label"
                                        >Nombre completo</span
                                      >
                                      <strong class="person-name">
                                        {{ info.student_flast }}
                                        {{ info.student_slast }}
                                        {{ info.student_name }}
                                      </strong>
                                    </div>
                                  </div>
                                  <div class="result-identifier">
                                    <span>Código RUDE</span>
                                    <strong>{{ info.student_rude }}</strong>
                                  </div>
                                </article>

                                <article class="result-card">
                                  <div class="result-card-header">
                                    <div>
                                      <span class="result-eyebrow"
                                        >Titular de cobro</span
                                      >
                                      <h5>Información registrada</h5>
                                    </div>
                                    <span
                                      class="payment-status-chip"
                                      :class="{
                                        paid: state === 2,
                                        pending: state === 1,
                                      }"
                                    >
                                      {{ state === 2 ? "Pagado" : "Habilitado" }}
                                    </span>
                                  </div>

                                  <div class="person-summary">
                                    <div class="person-avatar" aria-hidden="true">
                                      <i class="bx bxs-user"></i>
                                    </div>
                                    <div class="person-summary__content">
                                      <span class="detail-label"
                                        >Nombre completo</span
                                      >
                                      <strong class="person-name">
                                        {{ info.titular_flast }}
                                        {{ info.titular_slast }}
                                        {{ info.titular_name }}
                                      </strong>
                                    </div>
                                  </div>

                                  <dl class="detail-grid">
                                    <div v-if="state === 1" class="detail-item">
                                      <dt>Carnet de identidad</dt>
                                      <dd>{{ info.titular_id_card }}</dd>
                                    </div>
                                    <div v-if="state === 1" class="detail-item">
                                      <dt>Fecha de nacimiento</dt>
                                      <dd>{{ info.titular_birth }}</dd>
                                    </div>
                                    <div class="detail-item detail-item--featured">
                                      <dt>Modalidad de pago</dt>
                                      <dd>
                                        {{
                                          info.payment_modality ||
                                          (person && person.payment_modality) ||
                                          "Sin información"
                                        }}
                                      </dd>
                                    </div>
                                    <div v-if="state === 2" class="detail-item">
                                      <dt>Entidad financiera</dt>
                                      <dd>{{ person.bank || "Sin información" }}</dd>
                                    </div>
                                    <div v-if="state === 2" class="detail-item">
                                      <dt>Fecha de pago</dt>
                                      <dd>{{ person.pay_date || "Sin información" }}</dd>
                                    </div>
                                  </dl>
                                </article>
                              </div>

                              <div class="result-note">
                                <i class="bx bx-info-circle" aria-hidden="true"></i>
                                <span>
                                  Los datos consolidados corresponden al día
                                  anterior.
                                </span>
                              </div>
                              <div class="result-actions">
                                <button
                                  type="button"
                                  class="new-search-button"
                                  @click="clearStudentForm"
                                >
                                  <i class="bx bx-search-alt-2" aria-hidden="true"></i>
                                  Consultar otro estudiante
                                </button>
                              </div>
                            </div>
                          </transition>
                          <template v-if="!info">
                            <form role="form" class="search-form-fields">
                              <div class="keyrus-flex-start">
                                <label for="" class="" style="">
                                  <span class="keyrus-text-danger">*</span>
                                  Rude:
                                </label>
                                <base-input
                                  alternative
                                  class="mb-3"
                                  placeholder="Rude"
                                  addon-left-icon="ni ni-hat-3"
                                  v-model="rude"
                                  aria-label="Rude del estudiante"
                                >
                                </base-input>
                              </div>

                              <div class="keyrus-flex-start">
                                <label for="" class="" style="">
                                  <span class="keyrus-text-danger">*</span>
                                  Fecha de Nacimiento:
                                </label>
                                <base-input
                                  alternative
                                  class="mb-3"
                                  placeholder="Fecha de nacimiento"
                                  type="date"
                                  addon-left-icon="ni ni-calendar-grid-58"
                                  v-model="birtdate"
                                  aria-label="Fecha de nacimiento del estudiante"
                                >
                                </base-input>
                              </div>

                              <div class="text-center">
                                <base-button
                                  color="primary"
                                  customClass="my-4"
                                  @click="checkStudent"
                                  :disabled="studentLoading"
                                >
                                  <i
                                    class="bx bx-loader-alt bx-spin"
                                    v-if="studentLoading"
                                  ></i>
                                  <span v-else>Buscar</span></base-button
                                >
                                <base-button
                                  color="secondary"
                                  customClass="my-4"
                                  @click="clearStudentForm"
                                  >limpiar</base-button
                                >
                              </div>
                            </form>
                          </template>
                        </card>
                      </div>
                    </transition>
                    <transition name="fade" mode="out-in">
                      <div v-if="activeTab === 'tab2'">
                        <card
                          type="secondary"
                          shadow
                          header-classes="bg-white pb-5"
                          body-classes="px-lg-5 py-lg-5"
                          class="border-0 form-container-card"
                        >
                          <p v-if="!info_titular" class="form-description">
                            Ingrese el carnet de identidad y la fecha de
                            nacimiento del titular para verificar los
                            estudiantes asociados.
                          </p>
                          <div
                            :class="`alert alert-${
                              titular_state ? 'success' : 'danger'
                            } keyrus-flex-center`"
                            role="alert"
                            v-if="titular_message"
                          >
                            {{ titular_message }}
                            <i
                              class="bx bx-info-circle"
                              style="font-size: 25px; padding-left: 5px"
                            ></i>
                          </div>

                          <transition name="fade">
                            <div class="results-container" v-if="info_titular">
                              <header class="results-heading">
                                <div>
                                  <span class="result-eyebrow">Resultado de la consulta</span>
                                  <h3>Información del titular y beneficiarios</h3>
                                </div>
                                <span class="results-heading-icon" aria-hidden="true">
                                  <i class="bx bx-group"></i>
                                </span>
                              </header>
                              <div class="result-grid result-grid--holder">
                                <article class="result-card holder-summary-card">
                                  <div class="result-card-header">
                                    <div>
                                      <span class="result-eyebrow"
                                        >Titular de cobro</span
                                      >
                                      <h5>Información registrada</h5>
                                    </div>
                                    <div class="person-avatar" aria-hidden="true">
                                      <i class="bx bxs-user"></i>
                                    </div>
                                  </div>
                                  <div class="person-summary person-summary--compact">
                                    <div class="person-summary__content">
                                      <span class="detail-label"
                                        >Nombre completo</span
                                      >
                                      <strong class="person-name">
                                        {{ info_titular.titular.paterno }}
                                        {{ info_titular.titular.materno }}
                                        {{ info_titular.titular.nombre }}
                                      </strong>
                                    </div>
                                  </div>
                                  <div class="holder-student-count">
                                    <strong>{{ info_titular.students.length }}</strong>
                                    <span>
                                      {{
                                        info_titular.students.length === 1
                                          ? "estudiante asociado"
                                          : "estudiantes asociados"
                                      }}
                                    </span>
                                  </div>
                                </article>

                                <article class="result-card students-result-card">
                                  <div class="result-card-header">
                                    <div>
                                      <span class="result-eyebrow"
                                        >Beneficiarios</span
                                      >
                                      <h5>Estudiantes asociados</h5>
                                    </div>
                                  </div>

                                  <div class="student-payment-list">
                                    <div
                                      v-for="(student, index) in info_titular.students"
                                      :key="student.codigo_rude || index"
                                      class="student-payment-row"
                                    >
                                      <div class="student-payment-identity">
                                        <span class="detail-label">RUDE</span>
                                        <strong>{{ student.codigo_rude }}</strong>
                                      </div>
                                      <div class="student-payment-method">
                                        <span class="detail-label"
                                          >Modalidad de pago</span
                                        >
                                        <strong>
                                          {{
                                            student.payment_modality ||
                                            "Sin información"
                                          }}
                                        </strong>
                                      </div>
                                      <span
                                        class="payment-status-chip"
                                        :class="{
                                          paid:
                                            student.payment_status === 'PAGADO',
                                          pending:
                                            student.payment_status !== 'PAGADO',
                                        }"
                                      >
                                        {{
                                          student.payment_status === "PAGADO"
                                            ? "Cobrado"
                                            : student.payment_status ===
                                                "PENDIENTE_CONFIRMACION"
                                              ? "Pendiente de confirmación"
                                              : "Pendiente"
                                        }}
                                      </span>
                                    </div>
                                  </div>
                                </article>
                              </div>
                              <div class="result-note">
                                <i class="bx bx-info-circle" aria-hidden="true"></i>
                                <span>
                                  Los datos consolidados corresponden al día
                                  anterior.
                                </span>
                              </div>
                              <div class="result-actions">
                                <button
                                  type="button"
                                  class="new-search-button"
                                  @click="clearTitularForm"
                                >
                                  <i class="bx bx-search-alt-2" aria-hidden="true"></i>
                                  Consultar otro titular
                                </button>
                              </div>
                            </div>
                          </transition>

                          <template v-if="!info_titular">
                            <div class="search-form-fields">
                              <div class="keyrus-flex-start">
                                <label for="" class="" style="">
                                  <span class="keyrus-text-danger">*</span>
                                  Carnet de Identidad:
                                </label>
                                <base-input
                                  alternative
                                  class="mb-3"
                                  placeholder="Numero de Carnet de Identidad"
                                  addon-left-icon="bx bxs-id-card"
                                  v-model="identity_card"
                                  aria-label="Carnet de identidad del titular"
                                >
                                </base-input>
                              </div>
                              <div class="keyrus-flex-start">
                                <label for="" class="" style="">
                                  Complemento:
                                </label>
                                <base-input
                                  alternative
                                  class="mb-3"
                                  placeholder="complemento"
                                  addon-left-icon="bx bxs-id-card"
                                  v-model="complement"
                                  aria-label="Complemento del carnet de identidad"
                                >
                                </base-input>
                              </div>

                              <div class="keyrus-flex-start">
                                <label for="" class="" style="">
                                  <span class="keyrus-text-danger">*</span>
                                  Fecha de Nacimiento:
                                </label>
                                <base-input
                                  alternative
                                  class="mb-3"
                                  placeholder="Fecha de nacimiento"
                                  type="date"
                                  addon-left-icon="ni ni-calendar-grid-58"
                                  v-model="titular_birtdate"
                                  aria-label="Fecha de nacimiento del titular"
                                >
                                </base-input>
                              </div>

                              <div class="text-center">
                                <base-button
                                  type="primary"
                                  color="primary"
                                  class="my-4"
                                  @click="checkTitular"
                                  :disabled="titularLoading"
                                >
                                  <i
                                    class="bx bx-loader-alt bx-spin"
                                    v-if="titularLoading"
                                  ></i>
                                  <span v-else>Buscar</span></base-button
                                >

                                <base-button
                                  color="secondary"
                                  type="secondary"
                                  class="my-4"
                                  @click="clearTitularForm"
                                  >limpiar</base-button
                                >
                              </div>
                            </div>
                          </template>
                        </card>
                      </div>
                    </transition>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-5 py-5 border-top text-center"></div>
          </div>
        </card>
      </div>
    </section>
  </div>
</template>
<script setup>
import { onMounted, ref, nextTick, watch } from "vue";
import BjpService from "../services/BjpService";
import { Howl, Howler } from "howler";

// const listVideos = [video1, video2, video3, video4];
const currentVideo = ref("");
const rude = ref("");
const birtdate = ref("");
const person = ref(null);
const has_state = ref(false);
const state_message = ref(null);
const isCase2 = ref(false);
const iscase3 = ref(false);
const source = ref(null);
const state = ref(0);
const studentLoading = ref(false);
const titularLoading = ref(false);

const identity_card = ref("");
const name = ref("");
const father_last_name = ref("");
const mother_last_name = ref("");
const titular_birtdate = ref("");
const titular_state = ref("");
const complement = ref("");
const titular_message = ref(null);
const info = ref(null);
const info_titular = ref(null);
const activeTab = ref("tab1");

const loadVideo = async (videoSrc) => {
  isCase2.value = false;
  iscase3.value = false;
  if (videoSrc == video1) {
    isCase2.value = true;
  }
  if (videoSrc == video2) {
    iscase3.value = true;
  }
  currentVideo.value = videoSrc;
  await nextTick(); // Wait for the DOM to update
  if (videoPlayer.value) {
    videoPlayer.value.load(); // Reload the video element
    videoPlayer.value.play(); // Play the video
  }
};

const getStates = (state_color) => {
  let color = "primary";
  switch (state_color) {
    case 1:
      color = "success";
      break;
    case 2:
      color = "primary";
      break;
    case 3:
      color = "warning";
      break;
    case 4:
      color = "warning";
      break;
  }
  return color;
};

const videoPlayer = ref(null);

const text = ref(
  "Felicidades eres beneficiario, puedes realizar el cobro en los siguientes puntos."
);
const voices = ref([]);
const spanishVoice = ref(null);

onMounted(() => {
  // Load available voices
  const loadVoices = () => {
    voices.value = window.speechSynthesis.getVoices();
    // Find a Spanish voice
    spanishVoice.value = voices.value.find((voice) =>
      voice.lang.startsWith("es")
    );
  };

  // Some browsers (e.g., Chrome) may not have voices available immediately
  if (window.speechSynthesis.onvoiceschanged !== undefined) {
    window.speechSynthesis.onvoiceschanged = loadVoices;
  } else {
    loadVoices();
  }
});

const speak = () => {
  const utterance = new SpeechSynthesisUtterance(text.value);
  if (spanishVoice.value) {
    utterance.voice = spanishVoice.value; // Use the Spanish voice
  } else {
    alert("Spanish voice not found!");
  }
  window.speechSynthesis.speak(utterance);
};

const clearStudentForm = () => {
  rude.value = "";
  birtdate.value = "";
  person.value = null;
  has_state.value = false;
  state_message.value = null;
  state.value = 0;
  info.value = null;
};

const clearTitularForm = () => {
  identity_card.value = "";
  complement.value = "";
  titular_birtdate.value = "";
  titular_state.value = "";
  titular_message.value = null;
  info_titular.value = null;
};
const playBJP = () => {
  const sound = new Howl({
    src: [source.value],
  });

  sound.play();
};

const checkStudent = async () => {
  if (rude.value && birtdate.value) {
    let payload = {
      rude: rude.value,
      birth: birtdate.value,
    };
    studentLoading.value = true;
    try {
      let response = await BjpService.getStudentBenefitStatus(payload);

      state_message.value = "";
      if (response.status !== 404) {
        has_state.value = true;
        state.value = response.data.state;
        info.value = null;
        person.value = null;
        // state.value = 1
        switch (state.value) {
          case 1: {
            //  loadVideo(video1)
            const benefitInfo = response.data.info || {};
            const isElectronicPayment =
              benefitInfo.roster_source === "PAGO_ELECTRONICO";
            state_message.value = isElectronicPayment
              ? `Estás habilitado para el Bono Juancito Pinto con la modalidad ${
                  benefitInfo.payment_modality || "de pago electrónico"
                }. La confirmación del pago está pendiente.`
              : "¡Felicidades! Eres beneficiario del Bono Juancito Pinto. Puedes realizar el cobro en los puntos autorizados.";
            source.value = "cases/case1.mp3";
            info.value = benefitInfo;
            break;
          }
          case 2:
            //  loadVideo(video2)
            state_message.value =
              "¡Felicidades! Según el registro, ya cobraste tu bono. A continuación, te muestro los detalles de tu cobro. ";
            source.value = "cases/case2.mp3";
            person.value = response.data.message.json_build_object;
            info.value = response.data.info;
            break;
          case 3:
            //  loadVideo(video3)
            state_message.value =
              "Lo lamento, no te encuentras habilitado para el cobro. Recuerda que el beneficio es para unidades educativas fiscales y de convenio, así como para centros de educación especial. ";
            source.value = "cases/case3.mp3";
            break;
          case 4:
            //  loadVideo(video4)
            state_message.value =
              " Debes verificar con tu Dirección Departamental de Educación los datos que fueron registrados por el director de tu unidad educativa y realizar el cambio si corresponde.";
            source.value = "cases/case4.mp3";
            break;
        }
      } else {
        state_message.value =
          "No se encontraron datos del estudiante. Verifica que los datos ingresados sean correctos.";
      }
    } catch (error) {
      state_message.value =
        "No se encontraron datos del estudiante. Verifica que los datos ingresados sean correctos.";
    } finally {
      studentLoading.value = false;
    }
  } else {
    state_message.value = "Debe llenar el formulario con los datos solicitados.";
  }
};

const checkTitular = async () => {
  if (identity_card.value && titular_birtdate.value) {
    let payload = {
      idCard: identity_card.value.toUpperCase(),
      complement: complement.value ? complement.value.toUpperCase() : "",
      // name: name.value.toUpperCase(),
      // fLast: father_last_name.value.toUpperCase() ,
      // sLast: mother_last_name.value.toUpperCase() ,
      birth: titular_birtdate.value,
    };
    titularLoading.value = true;
    try {
      let response = await BjpService.getHolderBenefitInformation(payload);
      if (response.status !== 404) {
        titular_state.value = true;
        titular_message.value = "Usted es titular para el cobro.";
        info_titular.value = response.data;
        // state.value = 1
      } else {
        titular_state.value = false;
        titular_message.value = "Usted no es titular para el cobro.";
        info_titular.value = null;
      }
    } catch (error) {
      titular_state.value = false;
      titular_message.value = "Usted no es titular para el cobro.";
      info_titular.value = null;
    } finally {
      titularLoading.value = false;
    }
  } else {
    titular_state.value = false;
    titular_message.value =
      "Debe llenar el formulario con los datos solicitados.";
    info_titular.value = null;
  }
};
</script>

<style scoped>
.profile-page {
  overflow-x: hidden;
}

.search-hero-content {
  align-items: flex-start;
  padding-top: 4.5rem !important;
  padding-bottom: 3.5rem !important;
}

.search-hero-content > .col {
  margin-top: 0 !important;
}

.search-page-title {
  width: fit-content;
  margin: 0;
  padding: 0;
  color: var(--bjp-petrol-950);
  font-size: clamp(2.2rem, 5vw, 3.8rem);
  font-weight: 800;
  line-height: 1.08;
  text-shadow: none;
}

.search-page-title span {
  display: block;
  margin-top: 0.5rem;
  color: rgba(6, 47, 54, 0.72);
  font-size: 0.48em;
  font-weight: 650;
  letter-spacing: 0.02em;
}

.shape-style-1 span {
  display: none;
}

.shape-style-1 span:nth-child(1) {
  animation-delay: 1s;
}
.shape-style-1 span:nth-child(2) {
  animation-delay: 3s;
}
.shape-style-1 span:nth-child(3) {
  animation-delay: 5s;
}
.shape-style-1 span:nth-child(4) {
  animation-delay: 2s;
}
.shape-style-1 span:nth-child(5) {
  animation-delay: 4s;
}

@keyframes float {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-20px);
  }
  100% {
    transform: translateY(0px);
  }
}

input {
  margin-right: 10px;
}

.section-profile-cover {
  height: 330px !important;
}
.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  opacity: 1;
}

.search-button {
  font-weight: bold;
}
.card-profile-crystal {
  width: min(100%, 1180px);
  background: rgba(6, 47, 54, 0.78);
  border-radius: 28px;
  box-shadow: 0 24px 64px rgba(61, 57, 39, 0.16);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(230, 203, 114, 0.3);
  margin-right: auto;
  margin-left: auto;
  transition: all 0.3s ease;
  margin-top: -80px !important;
}

.card-profile-crystal:hover {
  box-shadow: 0 28px 70px rgba(61, 57, 39, 0.2);
}

.keyrus-flex-start label {
  color: #ffffff;
  font-weight: 650;
  margin-bottom: 5px;
}

.alert {
  border-radius: 10px;
  font-weight: bold;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.results-container {
  margin: 1.5rem 0 0.75rem;
  padding: 1rem;
  overflow: hidden;
  text-align: left;
  border: 1px solid rgba(230, 203, 114, 0.18);
  border-radius: 18px;
  background: rgba(6, 47, 54, 0.38);
  animation: slide-up 0.5s ease;
}

.results-heading {
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
  padding: 0.25rem 0.25rem 0.85rem;
  border-bottom: 1px solid rgba(230, 203, 114, 0.16);
  gap: 1rem;
}

.results-heading > div {
  min-width: 0;
}

.results-heading h3 {
  margin: 0.2rem 0 0;
  color: var(--bjp-gold-400);
  font-size: clamp(1.1rem, 3vw, 1.4rem);
  font-weight: 750;
  line-height: 1.3;
  overflow-wrap: anywhere;
}

.results-heading-icon {
  display: grid;
  width: 42px;
  height: 42px;
  flex: 0 0 42px;
  color: var(--bjp-petrol-950);
  font-size: 1.35rem;
  border-radius: 12px;
  background: var(--bjp-gold-400);
  place-items: center;
}

.result-grid {
  display: grid;
  grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.1fr);
  gap: 1rem;
  align-items: start;
}

.result-grid--holder {
  grid-template-columns: minmax(230px, 0.7fr) minmax(0, 1.3fr);
}

.result-card {
  min-width: 0;
  padding: 1.25rem;
  background: rgba(8, 57, 65, 0.94);
  border: 1px solid rgba(230, 203, 114, 0.2);
  border-radius: 14px;
  box-shadow: 0 10px 30px rgba(6, 47, 54, 0.13);
  color: #ffffff;
}

.result-card > * {
  min-width: 0;
  max-width: 100%;
}

.result-card-header {
  display: flex;
  min-width: 0;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
}

.result-card-header > div {
  min-width: 0;
}

.result-card-header h5 {
  margin: 0.15rem 0 0;
  color: #ffffff;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.35;
}

.result-eyebrow,
.detail-label {
  display: block;
  color: var(--bjp-gold-400);
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  line-height: 1.35;
  text-transform: uppercase;
}

.result-identifier {
  display: flex;
  min-width: 0;
  max-width: 100%;
  flex-direction: column;
  margin-top: 1rem;
  padding: 0.75rem;
  background: rgba(230, 203, 114, 0.1);
  border: 1px solid rgba(230, 203, 114, 0.22);
  border-radius: 10px;
  color: #ffffff;
  gap: 0.25rem;
}

.result-identifier span {
  color: var(--bjp-gold-400);
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.result-identifier strong {
  display: block;
  min-width: 0;
  max-width: 100%;
  color: var(--bjp-gold-400);
  font-family: monospace;
  font-size: 0.94rem;
  font-variant-numeric: tabular-nums;
  line-height: 1.4;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.person-summary {
  display: flex;
  align-items: center;
  gap: 0.9rem;
  min-width: 0;
}

.person-summary__content {
  min-width: 0;
  max-width: 100%;
}

.person-summary--compact {
  align-items: flex-start;
}

.person-avatar {
  display: grid;
  place-items: center;
  width: 44px;
  height: 44px;
  flex: 0 0 44px;
  background: linear-gradient(145deg, var(--bjp-petrol-800), var(--bjp-petrol-700));
  border-radius: 12px;
  color: #ffffff;
  font-size: 1.35rem;
  box-shadow: 0 7px 16px rgba(6, 47, 54, 0.22);
}

.person-name {
  display: block;
  margin-top: 0.2rem;
  color: #ffffff;
  font-size: 1rem;
  line-height: 1.45;
  overflow-wrap: anywhere;
}

.detail-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.75rem;
  margin: 1rem 0 0;
}

.detail-item {
  min-width: 0;
  padding: 0.75rem;
  background: rgba(6, 47, 54, 0.5);
  border: 1px solid rgba(230, 203, 114, 0.14);
  border-radius: 10px;
}

.detail-item--featured {
  grid-column: 1 / -1;
  background: rgba(48, 105, 87, 0.28);
  border-color: rgba(135, 181, 142, 0.24);
}

.detail-item dt {
  margin-bottom: 0.3rem;
  color: var(--bjp-gold-400);
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.detail-item dd {
  margin: 0;
  color: #ffffff;
  font-size: 0.9rem;
  font-weight: 700;
  line-height: 1.4;
  overflow-wrap: anywhere;
}

.payment-status-chip {
  display: inline-flex;
  min-width: 0;
  max-width: 100%;
  align-items: center;
  justify-content: center;
  min-height: 29px;
  padding: 0.35rem 0.65rem;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 700;
  line-height: 1.2;
  text-align: center;
  white-space: normal;
  overflow-wrap: anywhere;
}

.payment-status-chip.paid {
  background: #daf5e7;
  color: #12653a;
}

.payment-status-chip.pending {
  background: rgba(230, 203, 114, 0.18);
  color: #ffffff;
}

.holder-student-count {
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 0.55rem;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #e4edf4;
  color: #ffffff;
}

.holder-student-count strong {
  color: #ffffff;
  font-size: 1.6rem;
  line-height: 1;
}

.holder-student-count span {
  font-size: 0.82rem;
  font-weight: 600;
}

.student-payment-list {
  display: grid;
  gap: 0.65rem;
}

.student-payment-row {
  display: grid;
  min-width: 0;
  grid-template-columns: minmax(105px, 0.75fr) minmax(140px, 1.25fr) minmax(90px, auto);
  gap: 1rem;
  align-items: center;
  padding: 0.85rem;
  background: rgba(6, 47, 54, 0.5);
  border: 1px solid rgba(230, 203, 114, 0.14);
  border-radius: 10px;
}

.student-payment-identity,
.student-payment-method {
  min-width: 0;
}

.student-payment-identity strong,
.student-payment-method strong {
  display: block;
  margin-top: 0.2rem;
  color: #ffffff;
  font-size: 0.85rem;
  line-height: 1.35;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.student-payment-identity strong {
  color: var(--bjp-gold-400);
  font-family: monospace;
  font-variant-numeric: tabular-nums;
}

.result-note {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.75rem;
  padding: 0.65rem 0.8rem;
  background: rgba(230, 203, 114, 0.1);
  border: 1px solid rgba(230, 203, 114, 0.2);
  border-radius: 10px;
  color: #ffffff;
  font-size: 0.78rem;
  line-height: 1.4;
}

.result-note span {
  min-width: 0;
  overflow-wrap: anywhere;
}

.result-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
}

.new-search-button {
  display: inline-flex;
  min-height: 44px;
  align-items: center;
  justify-content: center;
  padding: 0.7rem 1rem;
  color: var(--bjp-petrol-950);
  font-family: inherit;
  font-size: 0.84rem;
  font-weight: 750;
  border: 1px solid var(--bjp-gold-400);
  border-radius: 10px;
  background: var(--bjp-gold-400);
  box-shadow: 0 8px 20px rgba(6, 47, 54, 0.2);
  cursor: pointer;
  gap: 0.45rem;
  transition: background-color 0.2s ease, border-color 0.2s ease,
    transform 0.2s ease;
}

.new-search-button:hover,
.new-search-button:focus-visible {
  color: var(--bjp-petrol-950);
  border-color: var(--bjp-gold-200);
  background: var(--bjp-gold-200);
  outline: none;
  transform: translateY(-2px);
}

.new-search-button i {
  font-size: 1.15rem;
}

.result-note i {
  flex: 0 0 auto;
  color: #ffffff;
  font-size: 1.15rem;
}

.search-form-fields {
  width: min(100%, 560px);
  margin-top: 1.5rem;
  margin-right: auto;
  margin-left: auto;
}

@keyframes slide-up {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.form-container-card {
  border: none !important;
  box-shadow: none !important;
  border-radius: 20px;
  padding: 0;
  overflow: hidden;
  background: rgba(4, 38, 44, 0.72);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(230, 203, 114, 0.18) !important;
}

::v-deep .form-container-card > .card-body {
  min-width: 0;
  padding: clamp(1rem, 3vw, 2rem) !important;
}

.keyrus-flex-start {
  margin-bottom: 1.5rem;
}

.keyrus-flex-start label {
  color: #ffffff;
  font-weight: 600;
  margin-bottom: 0.5rem;
  display: block;
}

::v-deep .form-container-card .form-control {
  background-color: rgba(6, 47, 54, 0.78) !important;
  border: 1px solid rgba(230, 203, 114, 0.2) !important;
  color: #ffffff !important;
  border-radius: 10px;
}

::v-deep .form-container-card .form-control::placeholder {
  color: #ffffff;
}

::v-deep .form-container-card .input-group-text {
  background-color: rgba(6, 47, 54, 0.78) !important;
  border: none !important;
  color: #ffffff !important;
}

.btn-primary {
  background: var(--bjp-gold-400);
  color: var(--bjp-petrol-950);
  border: none;
  border-radius: 10px;
  font-weight: bold;
  transition: all 0.3s ease;
}

.btn-primary:hover {
  background: var(--bjp-gold-200);
  color: var(--bjp-petrol-950);
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}

.btn-secondary {
  background: rgba(230, 203, 114, 0.08);
  border: 1px solid rgba(230, 203, 114, 0.24);
  color: #ffffff;
  border-radius: 10px;
  font-weight: bold;
  transition: all 0.3s ease;
}

.btn-secondary:hover {
  background: rgba(230, 203, 114, 0.16);
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}

::v-deep .nav-pills .nav-link {
  background-color: rgba(230, 203, 114, 0.08) !important;
  color: #ffffff !important;
  font-weight: 650;
  border-radius: 10px;
  margin: 0 5px;
  transition: all 0.3s ease;
}

::v-deep .nav-pills .nav-link.active {
  background-color: var(--bjp-gold-400) !important;
  color: var(--bjp-petrol-950) !important;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}
.form-description {
  color: #ffffff;
  text-align: center;
  margin-bottom: 1.5rem;
  font-style: italic;
}

@media (max-width: 991px) {
  .section-profile-cover {
    height: 300px !important;
  }
  .card-profile-crystal {
    margin-top: -65px !important;
  }
  .result-grid,
  .result-grid--holder {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 767px) {
  .section-profile-cover {
    height: 260px !important;
  }
  .card-profile-crystal {
    margin-top: -40px !important;
    border-radius: 20px;
  }
  .card-profile-crystal > .px-4 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }
  .card-profile-crystal h2 {
    font-size: clamp(1.65rem, 8vw, 2.1rem);
  }
  .search-hero-content {
    padding: 4.5rem 15px 2rem !important;
  }
  .search-page-title {
    font-size: clamp(1.9rem, 10vw, 2.7rem);
  }
  .form-container-card {
    padding: 0;
  }
  ::v-deep .form-container-card > .card-body {
    padding: 1rem !important;
  }
  .nav-wrapper {
    margin-bottom: 1rem;
  }
  ::v-deep .nav-pills .nav-link {
    margin: 0 0 0.5rem;
  }
  .alert {
    flex-wrap: wrap;
    font-size: 0.9rem;
    overflow-wrap: anywhere;
  }
  .results-container {
    margin-top: 1rem;
    padding: 0.75rem;
    border-radius: 14px;
  }
  .results-heading {
    align-items: flex-start;
  }
  .results-heading-icon {
    width: 38px;
    height: 38px;
    flex-basis: 38px;
    font-size: 1.2rem;
  }
  .result-card {
    padding: 1rem;
  }
  .result-card-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.65rem;
  }
  .detail-grid {
    grid-template-columns: 1fr;
  }
  .detail-item--featured {
    grid-column: auto;
  }
  .student-payment-row {
    grid-template-columns: 1fr;
    gap: 0.65rem;
  }
  .student-payment-row .payment-status-chip {
    justify-self: start;
  }
  .person-summary {
    align-items: flex-start;
  }
  .person-name {
    font-size: 0.92rem;
  }
  .result-identifier strong {
    font-size: 0.88rem;
  }
  .result-note {
    align-items: flex-start;
  }
  .new-search-button {
    width: 100%;
  }
  .mt-5.py-5.border-top {
    margin-top: 1.5rem !important;
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
}

@media (max-width: 400px) {
  .form-container-card {
    padding: 0;
  }
  ::v-deep .form-container-card > .card-body {
    padding: 0.7rem !important;
  }
  .text-center .btn {
    display: block;
    width: 100%;
    margin: 0.5rem 0 !important;
  }
  .result-card {
    padding: 0.8rem;
  }
  .results-container {
    padding: 0.55rem;
  }
  .results-heading {
    gap: 0.65rem;
  }
  .results-heading h3 {
    font-size: 1rem;
  }
  .result-identifier {
    max-width: 100%;
    padding: 0.65rem;
  }
}

@media (prefers-reduced-motion: reduce) {
  .new-search-button {
    transition: none;
  }
}
</style>
